import { useParams } from 'react-router-dom';

export const useHcpUrlParams = (suppressErrors: boolean = false) => {
	const { hcpId } = useParams<{ hcpId: string }>();

	if (!hcpId) {
		if (!suppressErrors) console.error('HCP ID is missing in the URL.');
		return { firstName: undefined, lastName: undefined, id: undefined };
	}

	const parts = hcpId.split('-');

	if (parts.length === 0) {
		if (!suppressErrors)
			console.error(
				'HCP ID format is invalid. Expected format: "firstName-lastName-id" or "name-id" or "id".'
			);
		return { firstName: undefined, lastName: undefined, id: undefined };
	}

	// The ID is the last part, everything before it forms the full name
	const id = parts.pop()!;
	const [firstName, ...lastNameParts] = parts;
	const lastName =
		lastNameParts?.length > 0 ? lastNameParts.join('-') : undefined;

	return {
		firstName:
			firstName?.length > 0
				? decodeURIComponent(firstName).split('-').join(' ').trim()
				: undefined,
		lastName: lastName
			? decodeURIComponent(lastName).split('-').join(' ').trim()
			: undefined,
		id: decodeURIComponent(id)
	};
};
